import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import legacySimulatorStep from './legacySimulatorStep.js';
export var schema = defineObject('legacySimulatorSection', {
    step1: {
        title: 'Step 1',
        type: 'legacySimulatorStep'
    },
    step2: {
        title: 'Step 2',
        type: 'legacySimulatorStep'
    },
    step3: {
        title: 'Step 3',
        type: 'legacySimulatorStep'
    },
    step4: {
        title: 'Step 4',
        type: 'legacySimulatorStep'
    }
}, [
    legacySimulatorStep.schema.legacySimulatorStep
]);
var validator = z.object({
    step1: legacySimulatorStep.validator,
    step2: legacySimulatorStep.validator,
    step3: legacySimulatorStep.validator,
    step4: legacySimulatorStep.validator
}).partial();
schema.legacySimulatorSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=legacySimulatorSection.js.map